import {Injectable} from '@angular/core';
import {RestService} from "./rest.service";

@Injectable({
  providedIn: 'root'
})
export class LineaService extends RestService {
  endpoint(): string {
    return "lineas";
  }
  param1(): string {
    return "nombre_ceco";
  }

  param2(): string {
    return "centro_costo";
  }

  param3(): string {
    return "";
  }
}


